import { API_STATUS } from 'constants/enums';
import { Auth, LoginViaQrTokenStatus } from 'types/Auth';

const INITIAL_STATE: Auth = {
  login: {
    viaQr: {
      status: LoginViaQrTokenStatus.IS_REFRESHING,
      value: '',
      expiryAt: null,
    },
  },
  ssoLogin: {
    freskDeskAPIStatus: API_STATUS.IDLE,
    redirectURI: '',
    clientInfo: {
      name: '',
      logo: '',
    },
    thirdPartyFetchAPIStatus: API_STATUS.IDLE,
    thirdPartyConfirmAPIStatus: API_STATUS.IDLE,
    thirdPartyAuthData: {
      redirect: false,
      uri: '',
      auth_code: '',
      state: '',
    },
  },
  consent: {
    isPending: false,
    preAuthToken: null,
  },
};

export default INITIAL_STATE;
